var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('TextBox',{attrs:{"derived":true,"type":"Number","maxval":13,"placeholder":_vm.placeholder,"id":_vm.id,"value":_vm.value,"label":_vm.label,"rules":'vat|' + _vm.rules},on:{"input":function($event){return _vm.emitUpdate()}},model:{value:(_vm.vat),callback:function ($$v) {_vm.vat=$$v},expression:"vat"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }